/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesProfileUpdateProfileSettingsRequest
 */
export interface FxIdWebFeaturesProfileUpdateProfileSettingsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof FxIdWebFeaturesProfileUpdateProfileSettingsRequest
     */
    DUMMY: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FxIdWebFeaturesProfileUpdateProfileSettingsRequest
     */
    MarketingEnabled?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesProfileUpdateProfileSettingsRequest
     */
    Language?: string | null;
}

/**
 * Check if a given object implements the FxIdWebFeaturesProfileUpdateProfileSettingsRequest interface.
 */
export function instanceOfFxIdWebFeaturesProfileUpdateProfileSettingsRequest(value: object): value is FxIdWebFeaturesProfileUpdateProfileSettingsRequest {
    if (!('DUMMY' in value) || value['DUMMY'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesProfileUpdateProfileSettingsRequestFromJSON(json: any): FxIdWebFeaturesProfileUpdateProfileSettingsRequest {
    return FxIdWebFeaturesProfileUpdateProfileSettingsRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesProfileUpdateProfileSettingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesProfileUpdateProfileSettingsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'DUMMY': json['__DUMMY'],
        'MarketingEnabled': json['MarketingEnabled'] == null ? undefined : json['MarketingEnabled'],
        'Language': json['Language'] == null ? undefined : json['Language'],
    };
}

export function FxIdWebFeaturesProfileUpdateProfileSettingsRequestToJSON(json: any): FxIdWebFeaturesProfileUpdateProfileSettingsRequest {
    return FxIdWebFeaturesProfileUpdateProfileSettingsRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesProfileUpdateProfileSettingsRequestToJSONTyped(value?: FxIdWebFeaturesProfileUpdateProfileSettingsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '__DUMMY': value['DUMMY'],
        'MarketingEnabled': value['MarketingEnabled'],
        'Language': value['Language'],
    };
}

